












































import { Component, Prop, Vue } from 'vue-property-decorator';
import './StoreProcessingDetails.scss';
import { formatNumber } from '@/utils/helpers';

@Component
export default class StoreProcessingDetails extends Vue {
  @Prop() detailButton!: any;
  @Prop(Array) item!: Array<any>;
  @Prop(Function) switchOrderDetail!: Function;
  @Prop() currentDetailItem!: any;
  @Prop(Function) checkOutItems!: Function;
  @Prop(Function) disabledExportButtonState!: Function;
  @Prop(Function) removeDisabled!: Function;
  currentItem: Object = {};
  resItem: Object = {};
  totalAmount: Object = this.currentDetailItem.paymentDetails;

  mounted() {
    for (let key in this.currentDetailItem.paymentDetails) {
      this.totalAmount[key] = formatNumber(
        this.currentDetailItem.paymentDetails
      );
    }
    if (this.item[0] === undefined) {
      this.checkOutItems();
      this.disabledExportButtonState();
    } else {
      this.removeDisabled();
    }
    if (this.item[0]) {
      this.switchOrderDetail(
        this.item[0].orderId,
        this.item[0].orderStatus,
        this.item[0].orderType,
        this.item[0].outletCode
      );
    }
  }
}
